// extracted by mini-css-extract-plugin
export default {"card":"Z4-z","carouselContainer":"_4-z","carouselContainerOverrides":"a5-z","carouselContent":"b5-z"};